import styled from 'styled-components'
import { StyledH1, StyledH2, StyledH5, colors } from '../../../theme/Global'

export const CustomH1 = styled(StyledH1)`
  font-size: 36px;
  text-align: left;
`

export const CustomLine = styled.div`
  background-color: ${colors.lightGrey};
  height: 1px;
`

export const CustomLineWithMargin = styled(CustomLine)`
  margin-top: 1rem;
  margin-bottom: 1rem;
`

export const CustomH2 = styled(StyledH2)`
  text-align: left;
`

export const CustomH5 = styled(StyledH5)`
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
  text-align: left;
`
